<p-drawer
  styleClass="floatbar"
  [(visible)]="visible"
  (onHide)="onHide()"
  [position]="position"
  [style]="{ width: currentDeviceService && !currentDeviceService.isMobile ? '530px' : 'calc(100% - 0px)' }"
  [dismissible]="false"
  [showCloseIcon]="false"
  [closeOnEscape]="false"
  >
  <form [formGroup]="form" (ngSubmit)="save()" class="sidebar-content">
    <header class="floatbar-header">
      <div class="row">
        <div>
          <h2 class="no-mg">
            {{ 'WRITE_MESSAGE.TITLE' | translate }}
          </h2>
        </div>
        <div class="row grid-xsm">
          <div class="cell">
            <button type="button" class="btn btn-link" (click)="cancel()">
              {{ 'COMMON.BUTTONS.CLOSE' | translate }}
            </button>
          </div>
          <div class="cell">
            <button [disabled]="!this.form.valid || (!this.isNew && !form.touched && !form.dirty)" type="submit" class="btn btn-primary">
              {{ 'COMMON.BUTTONS.SEND_MESSAGE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </header>

    <div class="floatbar-section">
      <ng-content></ng-content>
      @if (!sendToInsideEventOnly) {
        <div class="divider-h"></div>
      }
      @if (!sendToInsideEventOnly) {
        <fieldset class="form-group mt-16">
          <legend>
            {{ 'WRITE_MESSAGE.SEND_MESSAGE_TO' | translate }}
            @if (isRequired('action')) {
              <span class="color-danger"
                >*
                <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
              </span>
            }
          </legend>
          <div class="form-group">
            <label for="write-message-send-message-to-everyone" class="form-radio">
              <input formControlName="action" id="write-message-send-message-to-everyone" value="all" type="radio" name="action" /><i aria-hidden="true"></i>
              <span class="form-control-label">{{ 'WRITE_MESSAGE.EVERYONE' | translate }}</span>
            </label>
          </div>
          @if (!everyoneOptionOnly) {
            <div class="form-group">
              <label for="write-message-send-message-to-everyone-inside" class="form-radio">
                <input formControlName="action" id="write-message-send-message-to-everyone-inside" value="inside" type="radio" name="action" /><i aria-hidden="true"></i>
                <span class="form-control-label">{{ 'WRITE_MESSAGE.EVERYONE_INSIDE_EVENT' | translate }}</span>
              </label>
            </div>
          }
          @if (!everyoneOptionOnly) {
            <div class="form-group">
              <label for="write-message-send-message-to-everyone_hansnt_arrived" class="form-radio">
                <input formControlName="action" id="write-message-send-message-to-everyone_hansnt_arrived" value="outside" type="radio" name="action" /><i aria-hidden="true"></i>
                <span class="form-control-label">{{ 'WRITE_MESSAGE.EVERYONE_WHO_HAS_NOT_ARRIVED' | translate }}</span>
              </label>
            </div>
          }
          <!--                 <div class="form-group">
          <label for="write-message-send-message-select-recipients" class="form-radio">
            <input formControlName="sendMessageTo" id="write-message-send-message-select-recipients"
              value="select-recipients" type="radio" name="sendMessageTo"><i aria-hidden="true"></i> <span
            class="form-control-label">{{"WRITE_MESSAGE.SELECT_RECIPIENTS"|translate}}</span>
          </label>
        </div> -->
      </fieldset>
    }
    <!--             <div class="form-group">
    <div class="p-input-filled">
      <p-multiSelect formGroupName="selectedRecipients"
        [filter]="false"
        [emptyFilterMessage]="('COMMON.MESSAGES.NO_RESULTS'|translate)"
        [emptyMessage]="('COMMON.MESSAGES.NO_RESULTS'|translate)"
        [placeholder]="('WRITE_MESSAGE.SELECT_RECIPIENTS'|translate)" display="chip"
        optionLabel="name">
        <ng-template let-item pTemplate="item">
          <div class="row grid-xsm">
            <div class="cell">
              <img *ngIf="item.icon" [src]="item.icon" alt=""
                style="min-width: 14px" width="14" height="14"
                aria-hidden="true">
              </div>
              <div class="cell fg-1">{{item.name}}</div>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div> -->

    <div class="divider-h"></div>
    <div class="form-group mt-16">
      <label for="write-message-subject" class="form-label fz-14"
        >{{ 'WRITE_MESSAGE.SUBJECT' | translate }}
        @if (isRequired('subject')) {
          <span class="color-danger"
            >*
            <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
          </span>
          }</label
          >
          <div class="p-input-filled-light">
            <input formControlName="subject" type="text" id="write-message-subject" pInputText />
          </div>
        </div>
        <fieldset class="form-group">
          <legend>
            {{ 'WRITE_MESSAGE.MESSAGE_TYPE' | translate }}
            @if (isRequired('type')) {
              <span class="color-danger"
                >*
                <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
              </span>
            }
          </legend>
          <div class="row-inline grid-sm">
            <div class="cell">
              <label for="write-message-message-type-info" class="form-radio">
                <input formControlName="type" value="info" id="write-message-message-type-info" type="radio" name="type" /><i aria-hidden="true"></i>
                <span class="form-control-label">{{ 'WRITE_MESSAGE.MESSAGE_TYPE_INFO' | translate }}</span>
              </label>
            </div>
            <div class="cell">
              <label for="write-message-message-type-ad" class="form-radio">
                <input formControlName="type" value="ad" id="write-message-message-type-ad" type="radio" name="type" /><i aria-hidden="true"></i>
                <span class="form-control-label">{{ 'WRITE_MESSAGE.MESSAGE_TYPE_AD' | translate }}</span>
              </label>
            </div>
          </div>
        </fieldset>
        <div class="form-group">
          <label for="write-message-message" class="form-label fz-14"
            >{{ 'WRITE_MESSAGE.MESSAGE' | translate }}
            @if (isRequired('body')) {
              <span class="color-danger"
                >*
                <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
              </span>
              }</label
              >
              <div class="p-input-filled-light">
                <textarea formControlName="body" id="write-message-message" pInputTextarea class="w-stretch" rows="4"></textarea>
              </div>
            </div>
          </div>
        </form>
      </p-drawer>
